import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError, GetListRequestParams } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ResellerReferralOrdersResponse } from "../../resellers.types";
import { requestGetResellerReferralOrders } from "./getResellerReferralOrders.request";

const useGetResellerReferralOrders = (
  resellerId: string,
  referralId: string,
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    ResellerReferralOrdersResponse,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: [
      "reseller",
      resellerId,
      "referrals",
      referralId,
      "orders",
      requestParams
    ],
    queryFn: async () =>
      await requestGetResellerReferralOrders(
        resellerId,
        referralId,
        requestParams
      ),
    enabled: !!resellerId && !!referralId,
    keepPreviousData: true,
    ...options
  });

  return {
    orders: data?.data,
    meta: data?.meta,
    totalSpent: data?.totalSpent,
    commissionGenerated: data?.commissionGenerated,
    lastOrderAt: data?.lastOrderAt,
    ...rest
  };
};

export default useGetResellerReferralOrders;
